import { GridColumnProps } from "@progress/kendo-react-grid";
import { IVesselFolder } from "interface/vessel";
import i18n from "i18n";
import CustomButton from "ui/Button";
import { GrideDateFormatter } from "ui/Date";
import { ICON_NAMES } from "utils/constant";
import { t } from "i18next";

export const DocumentsGridColumnItem = (): GridColumnProps[] => [
	{
		field: "fileName",
		title: "",
		headerClassName: "no-border",
	},
	{
		field: "fileName",
		title: i18n.t("Name"),
		headerClassName: "no-border",
	},
	{
		field: "description",
		title: i18n.t("Description"),
		headerClassName: "no-border",
	},
	{
		field: "contentType",
		title: i18n.t("AttachmentContentType"),
		headerClassName: "no-border",
	},

	{
		field: "timeCreated",
		title: i18n.t("Date"),
		headerClassName: "no-border",
		cells: {
			data: (props) => (
				<GrideDateFormatter
					date={props.dataItem.timeCreated}
					formatType={"dd.MM.yyyy"}
				/>
			),
		},
	},
	{
		field: "createdByUsername",
		title: i18n.t("Username"),
		headerClassName: "no-border",
	},
];

interface FolderActions {
	onAddFile?: (folder: IVesselFolder) => void;
	onDeleteFolder?: (folder: IVesselFolder) => void;
	canCreate?: boolean;
	canDelete?: boolean;
}

export const FoldersGridColumnItem = (
	actions: FolderActions = {},
): GridColumnProps[] => [
	{ field: "folderName", title: i18n.t("Name"), headerClassName: "no-border" },
	{
		field: "",
		title: "",
		width: "120px",
		headerClassName: "no-border",
		cells: {
			data: (props) => {
				const defaultFolder = "Dokumenter";
				const isDefaultFolder = props.dataItem.folderName === defaultFolder;
				return (
					<td {...props.tdProps} onClick={(event) => event.stopPropagation()}>
						<div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
							{actions.canCreate && (
								<CustomButton
									label={""}
									title={t("VesselFolderAddFile")}
									iconName={ICON_NAMES.Upload}
									onClick={() => {
										actions.onAddFile?.(props.dataItem);
									}}
									btnStyle={{
										height: "25px",
										width: "25px",
										backgroundColor: "transparent",
									}}
								/>
							)}
							{actions.canDelete && !isDefaultFolder && (
								<CustomButton
									label={""}
									title={t("VesselFolderDelete")}
									iconName={ICON_NAMES.Delete}
									onClick={() => {
										actions.onDeleteFolder?.(props.dataItem);
									}}
									btnStyle={{
										height: "25px",
										width: "25px",
										backgroundColor: "transparent",
									}}
								/>
							)}
						</div>
					</td>
				);
			},
		},
	},
];
